<template>
	<div id="page_getapp">
	</div>
</template>

<script>
	import Ajax from "@/components/Ajax";

	export default {
		name: 'app',
		components: {},
		data() {
			return {
				title: "",
				app4WindowsUrl: "",
				app4MacUrl: "",
				app4AndroidUrl: "",
				app4iOSUrl: "",
				appList:[],
				platform: ""
			};
		},
		computed:{
			isChinese:function(){
                return "zh" == this.currentLanguage;
			}
		},
		methods: {
			getParam(name) {
				let currentHash = window.location.hash;
				let paramstr = currentHash.substring(currentHash.indexOf("?") + 1);
				try {
					let params = new URLSearchParams(paramstr);
					return params.get(name);
				} catch (e) {
					console.error("解析参数出错:", e);
					return null;
				}
			},
			getAppList(platform) {
				let vm = this;

                let reqParams = {};
				console.log("getAppList");

				Ajax.get({
					get: {
						url: "./conf_v3.json",
						data: reqParams
					},
					then: function(res) {
						vm.appList = res.data;
						vm.appList.forEach(function(item) {console.log(item);
							if (item.system == "windows") {
								vm.app4WindowsUrl = item.url;
							} else if (item.system == "mac") {
								vm.app4MacUrl = item.url;
							} else if (item.system == "android") {
								vm.app4AndroidUrl = item.url;
							} else if (item.system == "iOS") {
                                vm.app4iOSUrl = item.url;
                            }
				        });
                        
						if (platform == "windows") {
                            vm.downloadApp(vm.app4WindowsUrl);
						} else if (platform == "mac") {
							vm.downloadApp(vm.app4MacUrl);
						} else if (platform == "android") {
							vm.downloadApp(vm.app4AndroidUrl);
						} else if (platform == "ios") {
							vm.downloadApp(vm.app4iOSUrl);
						}
					}
				});
			},
			downloadApp(url) {
				console.info("app url:" + url);
				window.location.href = url;
			}
		},
		mounted() {
			let platform = this.getParam("p");
			this.getAppList(platform);
		}
	}
</script>